import { Navigate } from 'react-router-dom';

const IndexPage = () => {
  return <Navigate to="/cvc" replace={true} />;
};

export default IndexPage;
